import { render, staticRenderFns } from "./MoveMaterialForm.vue?vue&type=template&id=7382888a&"
import script from "./MoveMaterialForm.vue?vue&type=script&lang=js&"
export * from "./MoveMaterialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports